module.exports = __webpack_public_path__ + "img/Ancho_Ver.eb3ad519.png";